<template>
  <div class="popup-delete-box">
    <!-- 删除 -->
    <gat-popup
      :class="[deleteData.popupType == 1 ? 'popup-delete' : 'popup-delete-2', popupActive === deleteData.popupFlag ? 'on' : 'off']"
      :title="''"
      :primary-button="deleteData.buttonText"
      @cancel="cancelPopup"
      @confirm="confirmPopup"
    >
      <template v-slot:content>
        <div class="popup-del-cnt">
          <div class="head">
            <i class="icon-box">
              <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
              >
                <icon-info-help class="path-icon-info-help" />
              </icon-base>
            </i>
             <span class="title">{{deleteData.title}}</span>
          </div>
          <div class="content" v-if="deleteData.popupType == 1">{{deleteData.content}}</div>
        </div>
      </template>
    </gat-popup>
  </div>
</template>

<script>
import GatPopup from '@/components/common/GatPopup'
import IconInfoHelp from '@/components/icons/typography/InfoHelp'

export default {
  name: 'popup-delete-box',
  components: { GatPopup, IconInfoHelp },
  props: {
    deleteData: {
      type: Object,
      default: {
        popupType: '1', // 1：有content内容， 2：无content内容
        popupFlag: 'delete', // 对应弹窗类型
        buttonText: '删除', // 按钮文字
        title: '确定删除吗？', // 标题
        content: '删除后可在 “回收站” 恢复哦' // 内容
      }
    },
    popupActive: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      // popupActive: '',
      Icons: {
        InfoHelp: {
          iconName: "",
          viewBox: "0 0 36 36",
          width: "36",
          height: "36"
          // iconColor: "#fff"
        }
      },
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  methods: {
    confirmPopup() {
      this.$emit('confirmPopup', this.popupActive);
    },
    cancelPopup() {
      this.$emit('cancelPopup')
    }
  },
  updated() {}, //生命周期 - 更新之后
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="scss" scoped>
.popup-delete-box {
  .popup-delete {
    &.off {
      display: none;
    }
    &::v-deep .popup-inner{
      width: 480px;
      height: 230px;
      .popup-head {
        border-bottom: 0 none;
      }
      .popup-content{
        font-size: 16px;
      }
      .popup-del-cnt {
        overflow: hidden;
        margin-top: -25px;
        .head {
          .icon-box {
            display: inline-block;
            margin-right: 12px;
            vertical-align: middle;
          }
          .title {
            display: inline-block;
            color: #333;
            vertical-align: middle;
          }
        }
        .content {
          font-size: 16px;
          text-align: center;
          padding: 20px 0;
          margin-top: 25px;
        }
      }
    }
  }
  .popup-delete-2 {
    // &::v-deep .popup-inner {
    //   width: 420px;
    //   height: 200px;
    // }
    .popup-del-cnt {
      margin-top: 10px;
      .head {
        text-align: center;
       }
    }
  }
}
</style>